module.exports = __webpack_public_path__ + "img/674d85c.jpg";